module.exports = __webpack_public_path__ + "img/argentina.1b145e05.svg";